import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { businessAreaSchema as schema } from '../../_validationSchema';
import { businessAreaAction as actions } from '../../_action/businessArea.action';
import { businessArea_model as model } from '../../_model';
import { businessAreaConstants as constants } from '../../_constants';

import { useSelector } from 'react-redux';

const BusinessArea = (props) => {
  const { t } = props;

  const header = { name: 'BusinessArea', icon: 'cubes' };
  const reducer = useSelector((state) => state.businessAreaOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'business-area';
  const menuCode = 'M_BUSI_AREA';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'Description' },
  ];
  let useService = () => {
    return [schema, actions, model, constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);
  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);
  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(BusinessArea);
